<script>
    import CommonHeaderWrap from '@/components/common/CommonHeaderWrap.vue';
    import YcHeader from './components/common/YcHeader.vue';

    export default {
        name: 'app',
        components: {
            YcHeader,
            CommonHeaderWrap
        },
        data () {
            return {
                iframe: window._CONFIG.iframe,
                siteInfo: window._CONFIG.siteInfo,
            };
        },
        computed: {
            mask () {
                return this.$store.state.maskShown.isShow;
            },
            maskZindex () {
                return this.$store.state.maskShown.zIndex;
            }
        },
        mounted () {
            this.mutationApp();
            this.showTips();
        },
        methods: {
            showTips () {
                if (window._CONFIG.question_data && window._CONFIG.question_data.preferences && window._CONFIG.question_data.preferences.show_modal_before_answered && window._CONFIG.question_data.preferences.modal_content) {
                    this.$modal.alert({
                        title: '提示',
                        text: `<div class="modal-tips" style="max-height: 50vh;overflow: auto">${ window._CONFIG.question_data.preferences.modal_content }</div>`
                    });
                }
            },
            mutationApp () {
                if (window.self === window.top) {
                    return;
                }
                this.$bus.$on('modal:show', (instance) => {
                    setTimeout(() => {
                        const rect = instance.$el.getBoundingClientRect();
                        const scrollTop = window.parent.document.scrollingElement.scrollTop;
                        const screenHeight = window.parent.innerHeight;
                        let $iframe = window.parent.document.querySelector(`#yjzj_iframe_${ window._CONFIG.question_data.id }`);
                        const iframeRect = $iframe.getBoundingClientRect();
                        const limit = $iframe.getBoundingClientRect().height - rect.height;
                        let result;
                        if (iframeRect.top > 0) {
                            // screenHeight - iframeRect.top
                            result = (screenHeight - rect.height) / 2 - iframeRect.top;
                        } else {
                            result = (screenHeight - rect.height) / 2 + scrollTop - this.$util.getElementTop($iframe);
                        }
                        if (result < 0) {
                            result = 0;
                        } else if (result > limit) {
                            result = limit;
                        }
                        instance.$el.style.top = `${ result }px`;
                    });
                });
                let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                if (MutationObserver) {
                    let element = document.querySelector('body');
                    this.observer = new MutationObserver(() => {
                        clearTimeout(this.timer);
                        this.timer = 0;
                        this.timer = setTimeout(() => {
                            this.$util.setIframeHeight();
                        }, 200);
                    });
                    this.observer.observe(element, {
                        attributes: true,
                        attributeFilter: ['style', 'class'],
                        subtree: true,
                        childList: true,
                        characterData: true
                    });
                }
            }
        }
    };
</script>
<template>
    <div class="container">
        <div v-if="!iframe">
            <yc-header v-if="(siteInfo.id>641000 && siteInfo.id < 641999) || (siteInfo.id>64190000 && siteInfo.id < 64190999)"/>
            <common-header-wrap v-else ref="header"></common-header-wrap>
        </div>
        <!--<common-navi-bar ref="navibar"></common-navi-bar>-->
        <div id="app" class="frame-container">
            <router-view></router-view>
        </div>
        <transition name="fade">
            <div class="modal-mask" v-show="mask" style="z-index: 10000" :style="{zIndex: maskZindex}">

            </div>
        </transition>
    </div>
</template>
<style lang="less" scoped>

    .container {
        width: 100%;
        min-height: 100%;
        height: auto;
    }

    #app {
        width: 100%;
        height: auto;
        border-radius: 0 5px 5px 5px;
        z-index: 1000;
        /*position: absolute;*/
        /*left: 0;*/
        /*top: 0;*/
        /*right: 0;*/
        /*bottom: 0;*/
    }

    .modal-mask {
        z-index: 9999;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .6);
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0;
    }
</style>
